import React from 'react';
import { ROVING_ITEM_ATTR, onRovingKeyDown, rovingTabIndex } from './rovingFocus';

// Segmented status filter. `options` is [{ value, label }]; `counts` maps
// option value -> number and renders a muted counter next to each label.
//
// radiogroup rather than tablist: there is no panel for `aria-controls` to
// point at — the group filters a list that is already on screen.
const StatusSegmented = ({ options, value, onChange, counts, label = 'Filter by status' }) => {
  const activeIndex = options.findIndex((opt) => opt.value === value);

  return (
    <div
      role="radiogroup"
      aria-label={label}
      // The handler sits on the container: the event bubbles up from the
      // button, so one listener serves the whole group.
      onKeyDown={onRovingKeyDown}
      className="bg-surface border border-line rounded-lg p-1 flex items-center gap-1"
    >
      {options.map((opt, index) => {
        const active = value === opt.value;
        const count = counts ? counts[opt.value] : null;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            // Roving tabindex: only the selected segment is in the tab order,
            // otherwise Tab would step through every option one by one.
            tabIndex={rovingTabIndex(active, index, activeIndex)}
            {...{ [ROVING_ITEM_ATTR]: '' }}
            onClick={() => onChange(opt.value)}
            className={`px-2 py-1 max-md:min-h-11 max-md:min-w-11 rounded-[5px] text-xs font-medium leading-4 transition-colors whitespace-nowrap focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus ${
              active
                ? 'bg-card text-ink shadow-control'
                : 'text-ink-muted hover:text-ink'
            }`}
          >
            {opt.label}
            {/* A colour token, not opacity: alpha on text dropped the counter
                below the contrast threshold. */}
            {count != null && <span className="ml-1 text-ink-placeholder">{count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default StatusSegmented;
